// NewValuationButton — creates a draft valuation (PSD §10.3). Presentation.

import { useStore } from '../../store/selectors';

export function NewValuationButton() {
  const createValuation = useStore((s) => s.createValuation);
  const settings = useStore((s) => s.settings);
  const navigate = useStore((s) => s.navigate);
  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => {
        const entity = settings.activeEntityName ?? 'New Entity';
        createValuation(entity);
        navigate('builder');
      }}
    >
      + New Valuation
    </button>
  );
}
